export default __webpack_public_path__ + "static/media/NRI_transaction_details.be82b322.xlsx";